import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
import { Grid, useMediaQuery } from "@mui/material";

function ItemApprove_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;

  const xMediaQuery = useMediaQuery("(max-width:1500px)");
  return (
    <div className="container-fluid ">
      {vPathName === "/ItemApproveSummary" ? (
        <Grid container>
          <Grid item xs={12} md={6}>
            <span className="breadcrumb-not-active"> Item Approve Summary</span>
          </Grid>
        </Grid>
      ) : vPathName === "/ItemApproveDetail" ? (
        <Grid container alignItems="center">
          <Grid item xs={10} sm={3.3} md={3} lg={xMediaQuery ? 2.3 : 1.8}>
            <Link
              to="/ItemApproveSummary"
              state={location}
              className={"breadcrumb-active mr-2"}
            >
              Item Approve Summary
            </Link>
          </Grid>

          <Grid item xs={2} sm={0.6} md={0.5} lg={xMediaQuery ? 0.4 : 0.25}>
            <ArrowForwardIos color="info" />
          </Grid>

          <Grid item xs={12} sm={7.9} md={8} lg={8}>
            <span className="breadcrumb-not-active">
              Item Approve Detail
            </span>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
}
export default ItemApprove_Breadcrumbs;
